import { render } from "./FlickitySlider.vue?vue&type=template&id=04af060b&scoped=true"
import script from "./FlickitySlider.vue?vue&type=script&lang=js"
export * from "./FlickitySlider.vue?vue&type=script&lang=js"

import "./FlickitySlider.vue?vue&type=style&index=0&id=04af060b&lang=scss&scoped=true"
import "./FlickitySlider.vue?vue&type=style&index=1&id=04af060b&lang=scss"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04af060b"]])

export default __exports__